import Section from '../../../../mixins/Section'
import config from '../../../../config'
import * as d3 from 'd3-selection'
import SvgLogo from '../../components/svgLogo/SvgLogo.vue'
import { easeBackOut } from 'd3-ease'
import 'd3-transition'
export default {
  components: {
    SvgLogo
  },
  mixins: [Section],
  name: 'CustomersView',
  data () {
    return {
      i18nGroupName: 'customers',
      customers: config.customers,
      svgMargin: 30
    }
  },
  mounted () {
    this.$nextTick(this.showLogos)
  },
  methods: {
    enter () {
    },
    leave (el, done) {
      const projects = d3.select('.customers-container')

      projects.selectAll('.project-logo')
        .transition()
        .duration(200)
        .style('top', '120px')
        .on('start', function () {
          d3.select(this.parentNode).classed('static', false)
        })

      projects.selectAll('.project-details')
        .transition()
        .duration(200)
        .style('top', '120px')
        .on('start', function () {
          d3.select(this.parentNode).classed('static', false)
        })
      projects.selectAll('.divider')
        .transition()
        .ease(easeBackOut)
        .duration(400)
        .delay((d, i) => i * 40)
        .style('opacity', '0')
      // setTimeout(done, 1010)
    },
    showLogos () {
      if (d3.select('.customers-container').selectAll('.project').size() > 0) {
        const projects = d3.select('.customers-container')
        projects.selectAll('.project-logo')
          .transition()
          .ease(easeBackOut)
          .duration(400)
          .delay((d, i) => i * 40)
          .style('top', '30px')
          .on('end', function () {
            d3.select(this.parentNode).classed('static', true)
          })
        projects.selectAll('.project-details')
          .transition()
          .ease(easeBackOut)
          .duration(400)
          .delay((d, i) => i * 40)
          .style('top', '30px')
          .on('end', function () {
            d3.select(this.parentNode).classed('static', true)
          })
        projects.selectAll('.divider')
          .transition()
          .ease(easeBackOut)
          .duration(400)
          .delay((d, i) => i * 40)
          .style('opacity', '1')
      } else {
        setTimeout(this.showLogos, 20)
      }
    }
  }
}
